export default "__VITE_ASSET__CjCj$h2R__";